// ProductionsSection.jsx
import React from "react";
import "./ProductionsSection.css";


import { motion } from "framer-motion";

const ProductionsSection = ({ 
  backgroundImage, 
  title, 
  descriptions, 
  logos 
}) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <div className="Productions-container">
        <div className="image-wrapper">
          <img
            src={backgroundImage}
            alt="Spacetime Productions Wave Pattern"
            className="wave-image"
          />
        </div>

        <div className="content-wrapper-production">
          <h1>{title}</h1>
          
          {descriptions && descriptions.map((text, index) => (
            <p key={index}>{text}</p>
          ))}

          <div className="logos">
            {logos && logos.map((logoItem, index) => (
              <a 
                href={logoItem.href || "#"} 
                target="_blank" 
                rel="noopener noreferrer" 
                key={index}
              >
                <img
                  src={logoItem.src}
                  alt={logoItem.alt}
                  className="logo"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default ProductionsSection;